/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchises_Meta_Notfoundtitle2Inputs */

const id_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waralaba tidak ditemukan`)
};

const ms_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Francais tidak ditemui`)
};

const da_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franchise ikke fundet`)
};

const de_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franchise nicht gefunden`)
};

const en_us2_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franchise not found`)
};

const es_es2_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franquicia no encontrada`)
};

const es_mx2_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franquicia no encontrada`)
};

const fil_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nahanap ang franchise`)
};

const fr_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franchise non trouvée`)
};

const it_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franchise non trovato`)
};

const hu_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` franchise nem található`)
};

const nl_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franchise niet gevonden`)
};

const no_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franchise ikke funnet`)
};

const pl_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franczyza nie znaleziona`)
};

const pt_br2_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franquia não encontrada`)
};

const pt_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franquia não encontrada`)
};

const ro_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franciză negăsită`)
};

const fi_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sarjaa ei löydy`)
};

const sv_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serien hittades inte`)
};

const vi_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy thương hiệu`)
};

const tr_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seri bulunamadı`)
};

const cs_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franšíza nenalezena`)
};

const bg_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Франчайзът не е намерен`)
};

const ru_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Франшиза не найдена`)
};

const uk_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Франшизу не знайдено`)
};

const ar_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السلسلة غير موجودة`)
};

const hi_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़्रैंचाइज़ी नहीं मिली`)
};

const th_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบแฟรนไชส์`)
};

const ja_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フランチャイズが見つかりません`)
};

const zh_cn2_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系列未找到`)
};

const zh_hant1_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系列未找到`)
};

const ko_franchises_meta_notfoundtitle2 = /** @type {(inputs: Franchises_Meta_Notfoundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프랜차이즈를 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "Franchise not found" |
*
* @param {Franchises_Meta_Notfoundtitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const franchises_meta_notfoundtitle2 = /** @type {((inputs?: Franchises_Meta_Notfoundtitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchises_Meta_Notfoundtitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_franchises_meta_notfoundtitle2(inputs)
	if (locale === "ms") return ms_franchises_meta_notfoundtitle2(inputs)
	if (locale === "da") return da_franchises_meta_notfoundtitle2(inputs)
	if (locale === "de") return de_franchises_meta_notfoundtitle2(inputs)
	if (locale === "en-US") return en_us2_franchises_meta_notfoundtitle2(inputs)
	if (locale === "es-ES") return es_es2_franchises_meta_notfoundtitle2(inputs)
	if (locale === "es-MX") return es_mx2_franchises_meta_notfoundtitle2(inputs)
	if (locale === "fil") return fil_franchises_meta_notfoundtitle2(inputs)
	if (locale === "fr") return fr_franchises_meta_notfoundtitle2(inputs)
	if (locale === "it") return it_franchises_meta_notfoundtitle2(inputs)
	if (locale === "hu") return hu_franchises_meta_notfoundtitle2(inputs)
	if (locale === "nl") return nl_franchises_meta_notfoundtitle2(inputs)
	if (locale === "no") return no_franchises_meta_notfoundtitle2(inputs)
	if (locale === "pl") return pl_franchises_meta_notfoundtitle2(inputs)
	if (locale === "pt-BR") return pt_br2_franchises_meta_notfoundtitle2(inputs)
	if (locale === "pt") return pt_franchises_meta_notfoundtitle2(inputs)
	if (locale === "ro") return ro_franchises_meta_notfoundtitle2(inputs)
	if (locale === "fi") return fi_franchises_meta_notfoundtitle2(inputs)
	if (locale === "sv") return sv_franchises_meta_notfoundtitle2(inputs)
	if (locale === "vi") return vi_franchises_meta_notfoundtitle2(inputs)
	if (locale === "tr") return tr_franchises_meta_notfoundtitle2(inputs)
	if (locale === "cs") return cs_franchises_meta_notfoundtitle2(inputs)
	if (locale === "bg") return bg_franchises_meta_notfoundtitle2(inputs)
	if (locale === "ru") return ru_franchises_meta_notfoundtitle2(inputs)
	if (locale === "uk") return uk_franchises_meta_notfoundtitle2(inputs)
	if (locale === "ar") return ar_franchises_meta_notfoundtitle2(inputs)
	if (locale === "hi") return hi_franchises_meta_notfoundtitle2(inputs)
	if (locale === "th") return th_franchises_meta_notfoundtitle2(inputs)
	if (locale === "ja") return ja_franchises_meta_notfoundtitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_franchises_meta_notfoundtitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_franchises_meta_notfoundtitle2(inputs)
	return ko_franchises_meta_notfoundtitle2(inputs)
});
export { franchises_meta_notfoundtitle2 as "franchises.meta.notFoundTitle" }